const FlexCenter =({className,children})=>{
    return (
        <div className={`flex items-center ${className}`}>
            {children}
        </div>
    )
}

export default FlexCenter;